import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33af5e8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-instruction-label" }, " Is the truck a 3rd party or Swift/Knight truck? ", -1))
const _hoisted_2 = { class: "radio-container" }
const _hoisted_3 = { class: "radio-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "textfield-instruction-label" }, " Please provide some more details ", -1))
const _hoisted_5 = { class: "input-fields" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "textfield-instruction-label" }, " Please provide some more details ", -1))
const _hoisted_7 = { class: "input-fields" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FbxRadio = _resolveComponent("FbxRadio")!
  const _component_FbxInput = _resolveComponent("FbxInput")!
  const _component_FeedbackFormLayout = _resolveComponent("FeedbackFormLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.feedbackOption !== null && _ctx.isAttachedToAnotherTruck)
      ? (_openBlock(), _createBlock(_component_FeedbackFormLayout, {
          key: 0,
          isSubmitDisabled: _ctx.isSubmitDisabled,
          onOnNavigateBack: _ctx.onNavigateBack,
          onOnSubmit: _ctx.onSubmit
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          form: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_FbxRadio, {
                id: "third-party",
                label: "3rd party",
                name: "companyOrThirdParty",
                radioValue: _ctx.thirdParty,
                modelValue: _ctx.radioSelection,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radioSelection) = $event))
              }, null, 8, ["radioValue", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_FbxRadio, {
                id: "company",
                label: "Swift/Knight",
                name: "companyOrThirdParty",
                radioValue: _ctx.firstParty,
                modelValue: _ctx.radioSelection,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.radioSelection) = $event))
              }, null, 8, ["radioValue", "modelValue"])
            ]),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_FbxInput, {
                id: "trailerNumberSearch",
                class: "input-field",
                label: "Trailer Number",
                limit: 8,
                modelValue: _ctx.trailerNumber,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trailerNumber) = $event))
              }, null, 8, ["modelValue"]),
              (_ctx.showMcDotInput === true)
                ? (_openBlock(), _createBlock(_component_FbxInput, {
                    key: 0,
                    id: "mcDotNumber",
                    class: "input-field",
                    label: "MC/DOT",
                    limit: 20,
                    modelValue: _ctx.mcDotNumber,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mcDotNumber) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.showTruckNumberInput === true)
                ? (_openBlock(), _createBlock(_component_FbxInput, {
                    key: 1,
                    id: "truckNumber",
                    class: "input-field",
                    label: "Truck Number",
                    limit: 20,
                    modelValue: _ctx.truckNumber,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.truckNumber) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["isSubmitDisabled", "onOnNavigateBack", "onOnSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.feedbackOption !== null && !_ctx.isAttachedToAnotherTruck)
      ? (_openBlock(), _createBlock(_component_FeedbackFormLayout, {
          key: 1,
          isSubmitDisabled: _ctx.isSubmitDisabled,
          onOnNavigateBack: _ctx.onNavigateBack,
          onOnSubmit: _ctx.onSubmit
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          form: _withCtx(() => [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createVNode(_component_FbxInput, {
                  id: "trailerNumberSearch",
                  class: "input-field",
                  label: "Trailer Number",
                  limit: 8,
                  modelValue: _ctx.trailerNumber,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trailerNumber) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_FbxInput, {
                  id: "customerNameSearch",
                  class: "input-field",
                  label: "Customer Name",
                  modelValue: _ctx.customerName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.customerName) = $event)),
                  limit: 25
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["isSubmitDisabled", "onOnNavigateBack", "onOnSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}